<template>
    <section class="filtres">
        <div class="content">
            <div class="row spaceBetween">
                <h1>{{$t('filter.title')}}</h1>
                <div class="row">
                    <div class="space"></div>
                    <button class="outline" @click="$emit('wipe')">{{$t('button.wipe')}}</button>
                    <button @click="$emit('filter', filter)">{{$t('button.apply')}}</button>
                </div>
            </div>
        </div>
        <hr>
        <div class="content">
            <label>{{$t('productStatus.status')}}</label>
            <div class="row">
                <input type="checkbox" v-model="filter.isActive"/> <p>{{$t('productStatus.active')}}</p>
            </div>
            <div class="row">
                <input type="checkbox" v-model="filter.isArchived"/> <p>{{$t('productStatus.archived')}}</p>
            </div>
            <br>
            <div class="column">
                <label>{{$t('salesChannel.merchantName')}}</label>
            </div>
            <div class="column relative">
                <select class="mInput" @click="show.select = !show.select"></select>
                <div v-if="show.select" class="multiSelect">
                    <div v-for="merchant in merchantName" :key="merchant">
                        <div class="row">
                            <label class="checkbox">
                                <input type="checkbox" v-model="filter.merchantName[merchant]"/>
                                {{merchant}}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default { 
    props: ['options', 'products'],
    data() {
        return {
            merchantName: [],
            filter: {},
            show: {
                select: false
            }
        }
    },
    mounted() {
        this.getMerchant(),
        this.getDefaultFilter()
    },
    methods: {
        getMerchant() {
            let products = this.products
            let merchant = []
            for (let i = 0; i < products.length; i++) {
                merchant[i] = products[i]['merchantName'];
            }
            this.merchantName = [...new Set(merchant)]
        },
        getDefaultFilter() {
            this.filter = this.options
        }
    }
}
</script>

<style scoped>
.multiSelect {
    position: absolute;
    top: 45px;
    background-color:white;
    width: 218px;
    border: solid 1px lightgrey;
    
}
.checkbox {
    font-weight: 400;
    font-size: 1em;
    width: 100%;
    margin: 0;
    padding-left: 10px;
}
.checkbox:hover {
    background-color: #F1F1F1;
}
</style>